import { Card } from "react-bootstrap";
import { withNamespaces } from "react-i18next";
import { Spinner } from "reactstrap";

const ConfirmImportLoading = ({ t }) => (
    <Card className="p-3 shadow-sm text-center">
        <div className="d-flex justify-content-center align-items-center mb-3">
            <Spinner size='sm' color="primary" className="me-2" />
            <h5 className="mb-0">{t('Please wait')}...</h5>
        </div>
    </Card>
);

export default withNamespaces()(
    ConfirmImportLoading
);
